// Alt görev SÜRE hesaplama ve Türkçe biçimlendirme — TEK kaynak.
// Arayüz ve rapor (lib/taskExport.js) aynı yardımcıları kullanır; biçim
// mantığı hiçbir yerde tekrarlanmaz.
//
// Kurallar (ürün kararı):
//  - başlangıç + bitiş varsa  → kesin süre
//  - başlangıç var, bitiş yok, tamamlanmamış → "Devam ediyor (3 gün 4 saat)"
//  - bitiş var, başlangıç yok → "—" (bilinmiyor; tahmin YOK)
//  - bitiş < başlangıç        → NEGATİF süre ASLA yazılmaz, anomali döner

export const DUR_EXACT = "exact";
export const DUR_ONGOING = "ongoing";
export const DUR_UNKNOWN = "unknown";
export const DUR_ANOMALY = "anomaly";

const MIN = 60000;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;

// "1 gün 23 saat 30 dk" — sıfır birimler atlanır. 1 dakikadan kısa → "1 dk'dan az".
export const formatDurationTr = (ms) => {
  if (ms == null || !Number.isFinite(ms) || ms < 0) return "—";
  if (ms < MIN) return "1 dk'dan az";
  const days = Math.floor(ms / DAY);
  const hours = Math.floor((ms % DAY) / HOUR);
  const mins = Math.floor((ms % HOUR) / MIN);
  const parts = [];
  if (days) parts.push(`${days} gün`);
  if (hours) parts.push(`${hours} saat`);
  if (mins) parts.push(`${mins} dk`);
  return parts.join(" ");
};

const ms = (iso) => {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  return Number.isFinite(t) ? t : null;
};

// Tek düğüm (alt görev) süresi. `now` test edilebilirlik için enjekte edilebilir.
// Dönen: { kind, ms, text, anomaly }
export const subtaskDuration = (sub, now = Date.now()) => {
  const start = ms(sub?.start_date);
  const end = ms(sub?.completed_at);
  const isDone = !!(sub?.done || sub?.status === "done");

  if (start != null && end != null) {
    if (end < start) {
      return {
        kind: DUR_ANOMALY, ms: null, anomaly: true,
        text: "Bitiş tarihi başlangıçtan önce",
      };
    }
    return { kind: DUR_EXACT, ms: end - start, anomaly: false, text: formatDurationTr(end - start) };
  }
  if (start != null && end == null) {
    if (isDone) {
      // Tamamlanmış ama bitiş tarihi yok → süre bilinmiyor, uydurmuyoruz.
      return { kind: DUR_UNKNOWN, ms: null, anomaly: false, text: "—" };
    }
    return {
      kind: DUR_ONGOING, ms: now - start, anomaly: false,
      text: `Devam ediyor (${formatDurationTr(now - start)})`,
    };
  }
  return { kind: DUR_UNKNOWN, ms: null, anomaly: false, text: "—" };
};

// Ağacı (children dahil) düz listeye indir — süre toplamları TÜM seviyeleri kapsar.
const walk = (nodes, out = []) => {
  for (const n of nodes || []) {
    out.push(n);
    if (Array.isArray(n.children) && n.children.length) walk(n.children, out);
  }
  return out;
};

// Görev düzeyi iki toplam:
//  openToClose → görevin created_at'inden SON tamamlanan alt görev bitişine
//  work        → EN ERKEN alt görev başlangıcından SON tamamlanan bitişe
// Görev bitmemişse (tamamlanmamış alt görev varsa) "devam ediyor" olarak
// etiketlenir; yanıltıcı nihai sayı yazılmaz.
export const taskDurationTotals = (task, now = Date.now()) => {
  const all = walk(task?.subtasks);
  const starts = all.map((s) => ms(s.start_date)).filter((v) => v != null);
  const ends = all.map((s) => ms(s.completed_at)).filter((v) => v != null);
  const created = ms(task?.created_at);
  const lastEnd = ends.length ? Math.max(...ends) : null;
  const firstStart = starts.length ? Math.min(...starts) : null;
  const allDone = all.length > 0 && all.every((s) => s.done || s.status === "done");
  const anomaly = all.some((s) => subtaskDuration(s, now).anomaly);

  const build = (from) => {
    if (from == null) return { text: "—", ms: null, ongoing: false };
    if (allDone && lastEnd != null) {
      if (lastEnd < from) return { text: "Tarihler tutarsız", ms: null, ongoing: false, anomaly: true };
      return { text: formatDurationTr(lastEnd - from), ms: lastEnd - from, ongoing: false };
    }
    return {
      text: `Devam ediyor (${formatDurationTr(now - from)})`,
      ms: now - from, ongoing: true,
    };
  };

  return {
    openToClose: build(created),
    work: build(firstStart),
    anomaly,
    hasDates: starts.length > 0 || ends.length > 0,
  };
};

export const TOTAL_LABELS = {
  open_to_close: "Açılıştan bitişe",
  work: "Çalışma süresi",
};
